import {callApi} from '../api'

export const LOGIN = 'LOGIN';
export const LOGOUT = 'LOGOUT';
export const GET_AUTHENTICATED_USER = 'GET_AUTHENTICATED_USER';

export function login(cb, data) {
  return function (dispatch, getState) {
    return callApi(dispatch, getState, 'POST', '/authentication', Object.assign({strategy: 'local'}, data), LOGIN, cb).catch(error =>{
    });
  }
}

export function logout() {
  return {
    type: LOGOUT,
    value: true
  };
}

export function getAuthenticatedUser(cb) {
  return function (dispatch, getState) {
    return callApi(dispatch, getState, 'GET', '/users/' + getState().authentication.userId, null, GET_AUTHENTICATED_USER, cb);
  }
}



// WEBPACK FOOTER //
// ./src/actions/authentication.js